export class NyalaProject {
    id: string | null = null
    asset_id: string | null = null
    contract_id: string | null = null
    created_on: string | null = null
    custody_provider = 0
    external_project_id: string | null = null
    external_tokenized_asset_id: string | null = null
    integration_passphrase: string | null = null
    issuer_wallet_id: string | null = null
    issuer_wallet_seed_id: string | null = null
    unit_name: string | null = null
    updated_at: string | null = null
}
